import { TableDefinition } from "./table";

export class RowKey {
    private idColumnsIndexes: number[] = [];
    private idColumnsIndex: number;

    public constructor(definition: TableDefinition) {
        if (definition.idColumns == null) {
            return;
        }
        definition.idColumns.forEach((id) => {
            definition.columns.forEach((column, i) => {
                if (id === column.property) {
                    this.idColumnsIndexes.push(i);
                }
            });
            if (definition.extraFields != null) {
                definition.extraFields.forEach((field, i) => {
                    if (id === field) {
                        this.idColumnsIndexes.push(i + definition.columns.length);
                    }
                });
            }
        });
        if (this.idColumnsIndexes.length === 1) {
            this.idColumnsIndex = this.idColumnsIndexes[0];
        }

        if (this.idColumnsIndexes.length < definition.idColumns.length) {
            console.warn("Some idColumns so not match any column. Please review idColumn definition.", definition.idColumns);
        }
    }

    // public keys(data: any[][]): string[] {
    //     let keys = [];
    //     for (const rowData of data) {
    //         keys.push(this.key(rowData));
    //     }
    //     return keys;
    // }

    public key(data: any[]): string {
        if (this.idColumnsIndex != null) {
            if (data[this.idColumnsIndex] == null) {
                return null;
            } else {
                return "" + data[this.idColumnsIndex];
            }
        }
        let id = "";
        let allNull = true;
        this.idColumnsIndexes.forEach((index, i) => {
            if (i > 0) {
                id += "-";
            }
            const objValue = data[index];
            if (objValue != null) {
                allNull = false;
            }

            //If object, it could be SearcherWithSingleCode or SearcherWithComposedCode
            if (this.isSearcherWithCode(objValue)) {
                id += this.getCodeSearcherWithCode(objValue);
            } else {
                id += objValue;
            }
        });
        if (allNull) {
            return null;
        }
        return id;
    }

    private isSearcherWithCode(objValue: any): boolean {
        return (objValue != null && typeof objValue === 'object' && objValue.hasOwnProperty('code'));
    }

    private getCodeSearcherWithCode(objValue: any): string {
        let value = "";
        //SearcherWithComposedCode
        if (typeof objValue.code === 'object') {
            Object.keys(objValue.code).forEach(key => {
                value += objValue.code[key];
            });
            //SearcherWithSingleCode
        } else {
            value = objValue.code;
        }
        return value;
    }
}
